import { render, staticRenderFns } from "./StatisticsCards.vue?vue&type=template&id=7137fa0e&scoped=true&"
import script from "./StatisticsCards.vue?vue&type=script&lang=js&"
export * from "./StatisticsCards.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCards.vue?vue&type=style&index=0&id=7137fa0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7137fa0e",
  null
  
)

export default component.exports